export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').show();
    $('.js-nav-items').toggleClass('open');
    $(this).toggleClass('nav-trigger-active');
  });

  $('.menu-item-has-children').click(function (e) {
    if( $(window).width() < 960 ) {
      e.preventDefault();
      $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
        $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
      });
      $(this).children('.sub-menu').slideToggle(speed);
      $(this).toggleClass('menu-item-has-children--active');
    }
  });

  $('.sub-menu a').click(function () {
    location.href = $(this).attr('href');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').removeClass('open');
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  $(window).resize(function() {
    if( $(window).width() > 960 ) {
      $('.js-nav-items').show();
    } else {
      $('.js-nav-items').hide();
    }
  })

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
